import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";

function RequireRole({ roles }) {
    const user = useSelector((state) => state.user.user);
    const navigate = useNavigate();

    const isAllowed =
        user && Array.isArray(user.roles)
            ? roles.some((r) => user.roles.includes(r))
            : false;

    useEffect(() => {
        if (!isAllowed) {
            navigate("/not-found", { replace: true });
        }
    }, [isAllowed, navigate]);

    return isAllowed ? (
        <div>
            <Outlet/>
        </div>
    ) : null;
}

export default RequireRole;
